module.exports = __webpack_public_path__ + "img/2.a18a3a96.svg";